import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";

import { useAddDeliveryMutation } from "store/services/deliveryApi";
import DeliveryForm from "./DeliveryComponents/DeliveryForm";

const DeliveryCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Deliveries", path: "/app/crm/delivery/list" },
    { title: "Door Delivery" },
  ];

  // RTK query hook for adding a delivery
  const [addDelivery, { isLoading }] = useAddDeliveryMutation();

  const handleCreateDelivery = async (data) => {
    try {
      const { _id } = await addDelivery(data).unwrap();
      toast.success("Delivery successfully created!");
      navigate(`/app/crm/delivery/${_id}/detail`);
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create delivery!"
      );
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
      <BreadcrumbLayout.Paper>
        <DeliveryForm isBusy={isLoading} onSubmit={handleCreateDelivery} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default DeliveryCreateScreen; 
